<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p">
            <div class="w100p pt50 pb40">
                <div class="w1200 mauto">
                    <div class="textc mt20 mb20 ">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                智能化驾校培训
                            </span>
                        </p>
                        <p class="fs18 c666 pt18">
                            一部手机，让培训与管理更高效
                        </p>
                    </div>

                    <div class="overflow posre">
                        <div @click="prve()" class="posab left0 zindex9999 cursor" style="top: 45%;">
                            <img class="w60 h60" src="../../public/img/jiantou2.png" alt="">
                        </div>
                        <div @click="next()" class="posab right0 zindex9999 cursor" style="top: 45%;">
                            <img class="w60 h60" src="../../public/img/jiantou1.png" alt="">
                        </div>
                        <transition name="fade33" mode="out-in">
                            <div class="w100p  pt20 textc posre h100p" ref="element" @mousemove="showF()" v-show="banner==1">
                                <div class="w100p h100p posab top0 left0 zindex999 overflow">
                        
                                    <transition name="custom-classes-transition" enter-active-class="animated tada"
                                        leave-active-class="animated bounceOutRight">
                                        <div class="w148 h85 bg145 disinblock posab top240 left15p" v-if="showS==1">
                                            <div class="pl10 pr10 pt12">
                                                <p class="fs14 c333 ">学员APP：在线约课 练车时间，自己做主</p>
                                                <p @click="onStudents(1)" class="fs12 c349 pt3 cursor">查看界面></p>
                                            </div>
                                        </div>
                                    </transition>
                        
                                    <transition name="slide-fade">
                                        <div class="w148 h85 bg145 disinblock posab top145 left45p" v-if="showP==1">
                                            <div class="pl10 pr10 pt12">
                                                <p class="fs14 c333  ">校长APP：在线管理 统筹经营，掌控全局</p>
                                                <p @click="onStudents(2)" class="fs12 c349 pt3 cursor">查看界面></p>
                                            </div>
                                        </div>
                                    </transition>
                        
                        
                        
                                    <transition name="moveR">
                                        <div class="w148 h85 bg145 disinblock posab top500 left70" v-if="showT==1">
                                            <div class="pl10 pr10 pt12">
                                                <p class="fs14 c333  ">教练APP：在线教学 教学计划 一目了然</p>
                                                <p @click="onStudents(4)" class="fs12 c349 pt3 cursor">查看界面></p>
                                            </div>
                                        </div>
                                    </transition>
                        
                        
                        
                        
                                    <!-- 学员 -->
                                    <transition name="moveR">
                                        <div v-show="showStudents==1" class=" disinblock posab top100 " style="left: 28%;">
                                            <img class="imgauto posre zindex1" src="../../public/img/img146.png" alt="">
                                        </div>
                                    </transition>
                        
                        
                                    <!-- 校长 -->
                                    <transition name="moveR">
                                        <div v-show="showStudents==2" class=" disinblock posab" style="left: 58%;top: 60px;">
                                            <img class="imgauto posre zindex1" src="../../public/img/img144.png" alt="">
                                        </div>
                                    </transition>
                        
                                    <!-- 教练 -->
                                    <transition name="moveR">
                                        <div v-show="showStudents==4" class=" disinblock posab " style="left: 54%;top: 240px;">
                                            <img class="imgauto posre zindex1" src="../../public/img/img147.png" alt="">
                                        </div>
                                    </transition>
                        
                        
                                </div>
                                <img class="imgauto posre " style="width: 85%;" src="../../public/img/img7.png" alt="">
                            </div>
                        </transition>
                        <transition name="fade33" mode="out-in" >
                            <div class="w100p  pt20 textc posre h100p"  @mousemove="showF2()" ref="element" v-show="banner==2">
                                <div  class="w100p h100p posab  top0 left0 zindex999 overflow">
                        
                                    <transition name="fade22" >
                                        <div v-if="isShow1==1" class="w148 h85 bg145 disinblock posab " style="left: 35%;top:300px;">
                                            <div class="pl10 pr10 pt12">
                                                <p class="fs14 c333 ">学员APP:预的考试 随时随地 反馈及时</p>
                                                <p @click="onStudents(5)" class="fs12 c349 pt3 cursor">查看界面></p>
                                            </div>
                                        </div>
                                    </transition>
                        
                                    <transition name="fade22">
                                        <div  v-if="isShow2==1" class="w148 h85 bg145 disinblock posab "  style="left: 55%;top: 300px;">
                                            <div class="pl10 pr10 pt12">
                                                <p class="fs14 c333  ">教练APP :掌握洋情 统计数据 类別清晰</p>
                                                <p @click="onStudents(6)" class="fs12 c349 pt3 cursor">查看界面></p>
                                            </div>
                                        </div>
                                    </transition>
                        
                        
                        
                        
                                    <!-- 学员 -->
                                    <transition name="fade22">
                                        <div v-show="showStudents==5" class=" disinblock posab top100 " style="left: 18%;">
                                            <img class="imgauto posre zindex1" src="../../public/img/img266.png" alt="">
                                        </div>
                                    </transition>
                        
                        
                                  
                        
                                    <!-- 教练 -->
                                    <transition name="fade22">
                                        <div v-show="showStudents==6" class=" disinblock posab top100" style="left: 70%;">
                                            <img class="imgauto posre zindex1" src="../../public/img/img267.png" alt="">
                                        </div>
                                    </transition>
                        
                        
                                </div>
                                <img class="imgauto posre " style="width: 85%;" src="../../public/img/img7_1.png" alt="">
                            </div>
                        </transition>
                    </div>
                        
     
                </div>
            </div>


            <div class="w100p pt20 pb40">
                <div class="w1200 mauto ">
                    <div class="textc mt20 mb20 ">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                驾校培训管理系统
                            </span>
                        </p>
                        <p class="fs18 c666 pt18">
                        让驾校经营，一跃千里
                        </p>
                    </div>
                    <div class="w100p  mt40 display_flex justify-content_flex-justify">
                        <div class="minh200 pt10  w16p bg46 pl15 pr15 alit">
                           <div class="pt10 ">
                                <p class="pt10  fs16 c333 disblock w100p">驾校管理</p>
                                <p class="pt10  fs14 c999 disblock w100p">为驾校提供学员、教练，个性化教学计划管理服务。</p>
                           </div>
                        </div>
                        <div class="minh200 pt10  w16p  pl15 pr15 alit bg47">
                            <div class="pt10 ">
                                <p class="pt10  fs16 c333 disblock w100p">流量服务</p>
                                <p class="pt10  fs14 c999 disblock w100p">为驾校提供招生流量线索</p>
                            </div>
                        </div>
                        <div class="minh200 pt10  w16p  pl15 pr15 alit bg48">
                            <div class="pt10 ">
                                <p class="pt10  fs16 c333 disblock w100p">教学服务</p>
                                <p class="pt10  fs14 c999 disblock w100p">为教练提供完整的教学培训软件，线上线下无缝衔接</p>
                            </div>
                        </div>
                        <div class="minh200 pt10  w16p  pl15 pr15 alit bg49">
                            <div class="pt10 ">
                                <p class="pt10  fs16 c333 disblock w100p">培训服务</p>
                                <p class="pt10  fs14 c999 disblock w100p">为学员提供方便快捷的学车培训驾考一站式服务</p>
                            </div>
                        </div>
                        <div class="minh200 pt10  w16p  pl15 pr15 alit bg50">
                            <div class="pt10 ">
                                <p class="pt10  fs16 c333 disblock w100p">增值服务</p>
                                <p class="pt10  fs14 c999 disblock w100p">为驾校、学员提供招生、培训驾考各维度的实用、便捷服务</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w100p  pt50 pb40 mb40 posre">
                <img class="w100p zindex-1 posab" src="../../public/img/img9.png" alt="" style="height: 660px;">
                <div class="w1200  mauto mt50 posre h500">
                    <div class="disinblock w100p ">
                            <div v-if="actionShow==true"  class="h400 w100p">
                                <div class="w40p floatl disinblock">
                                    <div>
                                        <h4 class="fs38 fbold">驾校管理后台-集团版</h4>
                                        <ul>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">驾校专属：驾校专属域名与菜单类目。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">集团管理：集团总部管理，分校可独立经营管理。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">工 作 流 ：个性化定制工作流管理。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">考务管理：学员考试成绩与约考记录精准推送，秒查询。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">财务管理：财务统计，快速核算经营成本与利润。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">班型管理：班型个性化设置，满足招生服务差异化需求。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">学员管理：信息快速采集，关联教练，学习进度查询管理。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">人员管理：教练工作任务管理，考勤绩效管理。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">约课管理：多样约课模式任意组合，一键排班。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">车辆管理：行驶里程，维修记录，保险提醒合理管控。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">消息管理：驾校通知、公告、短信提醒线上管理与发布。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">数据管理：驾校经营数据、通过率快速呈现，秒分析。</span>
                                            </li>
                                        </ul>

                                        <div @click="activeShow()" class="bg1f8 pt10 pb10 pl20 pr20 cfff fs18 br20 disinblock mt25 cursor">
                                            查看管理后台
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="disinblock floatr bgswipe   h400 bottom-10 posab" style="padding-top:20px;bottom: -180px;width: 750px;height: 480px;">
                                    <div class=" mauto mt10  posre "  style="width: 476px;height: 260px;">
                                    
                                        <div class="overflow  posab w100p h100p left0 top0 zindex999 zoom1 indexbg">
                                           
                                                <!-- <li class="h100p overflow" v-if="isActive2==index" v-for="(item,index) in imgList2" :key="index">
                                                    <img :src="item" class="imgauto" alt="">
                                                </li> -->
                                                <swipe v-model="index1" :pagination='false' :autoplayTime='2000' class="h100p">
                                                    <swipe-item v-for="(item,index) in imgList2 " :key="index" class="h100p">
                                                        <img :src="item" class="imgauto" alt="">
                                                    </swipe-item>
                                                </swipe>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                            <div v-if="actionShow==false" class="h400 w100p">
                                <div class="w40p floatl disinblock">
                                    <div>
                                        <h4 class="fs38 fbold">驾校管理后台</h4>
                                        <ul>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">班型管理：班型个性化设置，满足招生服务差异化需求。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">学员管理：信息快速采集，关联教练，学习进度查询管理。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">人员管理：教练工作任务管理，考勤绩效管理。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">约课管理：多样约课模式任意组合，一键排班。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">车辆管理：行驶里程，维修记录，保险提醒合理管控。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">消息管理：驾校通知、公告、短信提醒线上管理与发布。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">数据管理：驾校经营数据、通过率快速呈现，秒分析。</span>
                                            </li>
                                            <li class="c787 mt18">
                                                <img class="w14 h14" src="../../public/img/img11.png">
                                                <span class="c787 fs16 ml10">成绩查询：全国唯一一家12123数据接口平台，考试成绩精准秒查询。</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div @click="activeShow()" class=" bg1f8 pt10 pb10 pl20 pr20 cfff fs18 br20 disinblock mt25 cursor">
                                        查看集团版
                                    </div>
                                </div>
                                

                                <div class="disinblock  floatr bgswipe  bottom-10 posab" style="padding-top:20px;bottom: -180px;width: 750px;height: 480px;">
                                    <div class=" mauto mt10  posre " style="width: 476px;height: 260px;">
                                        <div class="overflow  posab w100p h100p left0 top0 zindex999 zoom1 indexbg">
                                            <!-- <transition name="fade22">
                                                <li class="h100p overflow"  v-if="isActive==index" v-for="(item,index) in imgList " :key="index"  >
                                                    <img :src="item" class="imgauto" alt="">
                                                </li>
                                            </transition> -->
                                        <swipe v-model="index1" :pagination='false' :autoplayTime='2000' class="h100p">
                                            <swipe-item v-for="(item,index) in imgList " :key="index" class="h100p">
                                                <img :src="item" class="imgauto" alt="">
                                            </swipe-item>
                                        </swipe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                    </div>
                   
                    
             
                </div>
            </div>
            <div class="bgf6 w100p pt50 pb40">
                <div class="w1200 mauto">
                    <div class="textc pt20 pb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                驾培APP
                            </span>
                        </p>
                    </div>
                    <div class="textc border2 pt16 pb16">
                        <span class="fs20 c666 ml16 mr16  cursor" @click="activeIndex(0)"
                            :class="{'active':index==0}">驾校定制APP</span>
                        <span class="fs20 c666 ml16 mr16 cursor" @click="activeIndex(1)"
                            :class="{'active':index==1}">教练教学APP</span>
                        <span class="fs20 c666 ml16 mr16 cursor" @click="activeIndex(2)"
                            :class="{'active':index==2}">校长管理APP</span>
                    </div>
                    <div>
                        <transition name="plus-icon">
                            <div class="icon-plus overflow pt40" v-if="index == 0">
                                <div class="floatl w300  overflow h600 posre">
                                    <transition name="fade22" mode="out-in" >
                                        <img  v-if="showImg==1"  class="imgauto" src="../../public/img/img181.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                    <img  v-if="showImg==2" class="imgauto" src="../../public/img/img182.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                    <img  v-if="showImg==3" class="imgauto" src="../../public/img/img183.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                    <img  v-if="showImg==4" class="imgauto" src="../../public/img/img184.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                    <img  v-if="showImg==5" class="imgauto" src="../../public/img/img185.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                    <img  v-if="showImg==6" class="imgauto" src="../../public/img/img186.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                    <img  v-if="showImg==7" class="imgauto" src="../../public/img/img187.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                    <img  v-show="showImg==8" class="imgauto" src="../../public/img/img188.png">
                                    </transition>
                                   
                                </div>
                                <div  class="floatl  pt30 w900">
                                    <div class="">
                                        <p class="c333 fs30 pl64">驾校定制APP</p>
                                        <div class="w100p pl35">
                                            <ul class="w100p disinblock ml-10">
                                                <li @mousemove="moveImg(1)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img148.png">
                                                    <p class="white fs16 c333 textc pt20">驾校专属首页</p>
                                                </li>
                                                <li @mousemove="moveImg(2)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img149.png">
                                                    <p class="white fs16 c333 textc pt20">驾校专属场地设施展示</p>
                                                </li>
                                                <li @mousemove="moveImg(3)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img150.png">
                                                    <p class="white fs16 c333 textc pt20">驾校教练专属风采展示</p>
                                                </li>
                                                <li @mousemove="moveImg(4)"  class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img151.png">
                                                    <p class="white fs16 c333 textc pt20">全新模拟题库</p>
                                                </li>

                                                <li  @mousemove="moveImg(5)"  class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img152.png">
                                                    <p class="white fs16 c333 textc pt20">驾校专属教学视频</p>
                                                </li>
                                                <li  @mousemove="moveImg(6)"  class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img153.png">
                                                    <p class="white fs16 c333 textc pt20">在线预约上车练习</p>
                                                </li>
                                                <li  @mousemove="moveImg(7)"  class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img154.png">
                                                    <p class="white fs16 c333 textc pt20">在线预约考试一站式服务</p>
                                                </li>
                                                <li  @mousemove="moveImg(8)"  class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img155.png">
                                                    <p class="white fs16 c333 textc pt20">专属通知 新闻 服务栏目</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <transition name="plus-icon">
                        <div class="icon-plus overflow pt40" v-if="index == 1">
                            <div class="floatl w260 h500 overflow posre">
                                <transition name="fade22" mode="out-in">
                                    <img  v-show="showImg==1" class="imgauto" src="../../public/img/img193.png">
                                </transition>
                                <transition name="fade22" mode="out-in">
                                    <img  v-show="showImg==2" class="imgauto" src="../../public/img/img189.png">
                                </transition>
                                <transition name="fade22" mode="out-in">
                                    <img  v-show="showImg==3" class="imgauto" src="../../public/img/img191.png">
                                </transition>
                                <transition name="fade22" mode="out-in">
                                    <img  v-show="showImg==4" class="imgauto" src="../../public/img/img195.png">
                                </transition>
                                <transition name="fade22" mode="out-in">
                                    <img  v-show="showImg==5" class="imgauto" src="../../public/img/img194.png">
                                </transition>
                                <transition name="fade22" mode="out-in">
                                    <img  v-show="showImg==6" class="imgauto" src="../../public/img/img192.png">
                                </transition>

                            </div>
                            <div class="floatl  pt30 w940">
                                <div class="">
                                    <p class="c333 fs30 pl64">教练定制APP</p>
                                    <div class="w100p pl35">
                                        <ul class="w100p disinblock ml-10">
                                            <li @mousemove="moveImg(1)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                <img class="w140 h140" src="../../public/img/img170.png">
                                                <p class="white fs16 c333 textc pt20">课程/可教练自主排课</p>
                                            </li>
                                            <li @mousemove="moveImg(2)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                <img class="w140 h140" src="../../public/img/img171.png">
                                                <p class="white fs16 c333 textc pt20">教学任务管理</p>
                                            </li>
                                            <li @mousemove="moveImg(3)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                <img class="w140 h140" src="../../public/img/img172.png">
                                                <p class="white fs16 c333 textc pt20">教学日志记录查询</p>
                                            </li>
                                            <li @mousemove="moveImg(4)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                <img class="w140 h140" src="../../public/img/img173.png">
                                                <p class="white fs16 c333 textc pt20">学员学习进度查询、管理</p>
                                            </li>
                        
                                            <li @mousemove="moveImg(5)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                <img class="w140 h140" src="../../public/img/img174.png">
                                                <p class="white fs16 c333 textc pt20">学员学习状态日志点评</p>
                                            </li>
                                            <li @mousemove="moveImg(6)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                <img class="w140 h140" src="../../public/img/img175.png">
                                                <p class="white fs16 c333 textc pt20">一键联系学员</p>
                                            </li>
 
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </transition>
                        <transition name="plus-icon">
                            <div class="icon-plus overflow pt40" v-if="index == 2">
                                <div class="floatl w260 overflow h500 posre">
                                    <transition name="fade22" mode="out-in">
                                        <img  v-show="showImg==1" class="imgauto" src="../../public/img/img196.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                        <img  v-show="showImg==2" class="imgauto" src="../../public/img/img197.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                        <img  v-show="showImg==3" class="imgauto" src="../../public/img/img198.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                        <img  v-show="showImg==4" class="imgauto" src="../../public/img/img199.png">
                                    </transition>
                                    <transition name="fade22" mode="out-in">
                                        <img  v-show="showImg==5" class="imgauto" src="../../public/img/img200.png">
                                    </transition>
                                </div>
                                <div class="floatl  pt30 w940">
                                    <div class="">
                                        <p class="c333 fs30 pl64">校长定制APP</p>
                                        <div class="w100p pl35">
                                            <ul class="w100p disinblock ml-10">
                                                <li @mousemove="moveImg(1)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img176.png">
                                                    <p class="white fs16 c333 textc pt20">驾校招生数据统计分析</p>
                                                </li>
                                                <li @mousemove="moveImg(2)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img177.png">
                                                    <p class="white fs16 c333 textc pt20">驾校培训/考试数据分析</p>
                                                </li>
                                                <li @mousemove="moveImg(3)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img178.png">
                                                    <p class="white fs16 c333 textc pt20">教练考勤数据统计分析</p>
                                                </li>
                                                <li @mousemove="moveImg(4)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img179.png">
                                                    <p class="white fs16 c333 textc pt20">驾校教学培训进度分析</p>
                                                </li>
                                                <li @mousemove="moveImg(5)" class="disinblock w22p minh230 textc floatl box  pt35">
                                                    <img class="w140 h140" src="../../public/img/img180.png">
                                                    <p class="white fs16 c333 textc pt20">驾校教学调度统计分析</p>
                                                </li>
                            
                                               
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>

                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>  
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'


    import $ from "jquery";
    export default {
        data() {
            return {
                index1: 0,
                banner: 1,
                showS: 0,
                showP: 0,
                showT: 0,
                isShow1: 0,
                isShow2: 0,
                color: 3,
                titleList: 1,
                link: 0,
                logo: 'school',
                bgImg: require('../../public/img/img6.png'),
                actionShow: false,
                showStudents: 0,

                index: 0,
                showImg: 1,
                imgList: [
                    require('../../public/img/img239.png'),
                    require('../../public/img/img240.png'),
                    require('../../public/img/img241.png'),
                    require('../../public/img/img242.png'),
                    require('../../public/img/img243.png'),
                    require('../../public/img/img244.png'),
                    require('../../public/img/img245.png'),
                    require('../../public/img/img246.png'),
                    require('../../public/img/img247.png'),
                    require('../../public/img/img248.png'),
                    require('../../public/img/img249.png'),
                    require('../../public/img/img250.png'),
                    require('../../public/img/img251.png'),
                ],
                imgList2: [
                    require('../../public/img/img252.png'),
                    require('../../public/img/img253.png'),
                    require('../../public/img/img254.png'),
                    require('../../public/img/img255.png'),
                    require('../../public/img/img256.png'),
                    require('../../public/img/img257.png'),
                    require('../../public/img/img258.png'),
                    require('../../public/img/img259.png'),
                ],

            };
        },
        components: {
            Header,
            Footer,

        },
        methods: {
            prve() {
                if (this.banner > 1) {
                    this.banner = 1
                } else {
                    this.banner++;
                }
            },
            next() {
                if (this.banner < 2) {
                    this.banner = 2
                } else {
                    this.banner--;
                }
            },
            activeShow() {
                this.actionShow = !this.actionShow;
            },
            activeIndex(id) {
                this.index = id;
            },
            onStudents(id) {
                this.showStudents = id
            },
            moveImg(id) {
                this.showImg = id;
            },
            showF() {

                setTimeout(() => {
                    this.showS = 1
                }, 100);
                setTimeout(() => {
                    this.showP = 1
                }, 300);

                setTimeout(() => {
                    this.showT = 1
                }, 500);
            },
            showF2() {

                setTimeout(() => {
                    this.isShow1 = 1
                }, 100);
                setTimeout(() => {
                    this.isShow2 = 1
                }, 300);
            },

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>
    .fade22-enter-active {
        transition: opacity 1s;
        position: absolute;
    }
    
    .fade22-enter,
    .fade22-leave-to {
        opacity: 0;
    }
    
    .fade33-enter-active {
        transition: opacity 1s;
        /* position: absolute; */
    }
    
    .fade33-enter,
    .fade33-leave-to {
        opacity: 0;
    }
    
    .bgrow {
        background-image: url('../../public/img/img9.png');
        background-size: 100%;
        background-repeat: no-repeat;
    }
    
    .bgswipe {
        background-image: url('../../public/img/img10.png');
        background-size: 100%;
        background-repeat: no-repeat;
    }
    
    .active {
        color: #1f82f6;
        font-weight: 600;
        border-bottom: 2px solid #1f82f6;
        padding-bottom: 14px;
    }
    
    .plus-icon-enter-active {
        transition: opacity .1s;
    }
    
    .plus-icon-enter {
        opacity: 0;
    }
    
    .plus-icon-leave-active {
        transition: opacity .1s;
    }
    
    .plus-icon-leave-to {
        opacity: 0;
    }
    
    .plus-icon-enter-to {
        opacity: 1;
    }
    
    .bg46 {
        background-image: url('../../public/img/img46.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg47 {
        background-image: url('../../public/img/img47.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg48 {
        background-image: url('../../public/img/img48.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg49 {
        background-image: url('../../public/img/img49.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg50 {
        background-image: url('../../public/img/img50.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .bg145 {
        background-image: url('../../public/img/img145.png');
        background-repeat: no-repeat;
        background-size: 100%;
    }
    
    .mybox-leave-active,
    .mybox-enter-active {
        transition: all 1s ease;
    }
    
    .mybox-leave-active,
    .mybox-enter {
        height: 0px !important;
    }
    
    .mybox-leave,
    .mybox-enter-active {
        height: 380px;
    }
    
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    
    .slide-fade-leave-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    
    .slide-fade-enter,
    .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */
    
    {
        transform: translateX(10px);
        opacity: 0;
    }
    
    .bounce-enter-active {
        animation: bounce-in .5s;
    }
    
    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }
    
    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.5);
        }
        100% {
            transform: scale(1);
        }
    }
    
    .moveR-enter-active,
    .moveR-leave-active {
        transition: all 0.3s linear;
        transform: translateX(0);
    }
    
    .moveR-enter,
    .moveR-leave {
        transform: translateX(100%);
    }
    
    .moveR-leave-to {
        transform: translateX(100%);
    }
    
    .moveL-enter-active,
    .moveL-leave-active {
        transition: all 0.3s linear;
        transform: translateX(0%);
    }
    
    .moveL-enter,
    .moveL-leave {
        transform: translateX(-100%);
    }
    
    .moveL-leave-to {
        transform: translateX(-100%);
    }
</style>